/** Copy Media Lab — Harrison Mozo (@harriviral) × TNO Network */
export const harrisonMozoMediaLabWho = {
  title: 'Tu espacio en TNO Network: Harrison Mozo × TNO Media Lab',
  subtitle:
    '@harriviral pasa de contenido viral a programa propio en la plataforma TNO — producido en Media Lab con estándar broadcast.',
  description:
    'TNO Network abre un espacio editorial para Harrison Mozo (@harriviral): producción del programa en TNO Media Lab, publicación en streaming y on-demand de la red, clips para redes y piezas promocionales en YouTube que llevan audiencia a su espacio en tnonetwork.com.',
};

export const harrisonMozoMediaLabWhy = {
  title: '¿Por qué tener tu espacio en TNO Network?',
  description:
    'Infraestructura broadcast, grilla multiplataforma y tarifas claras para que @harriviral opere su programa con respaldo de TNO: producción $100, clips $50 adicional, bonificación en Digest y reparto 30%/50-50 en patrocinios.',
  ctaText: 'Agendar reunión',
};

export const harrisonMozoMediaLabBenefits = {
  overline: 'Espacio TNO',
  title: 'Tarifas para operar tu programa',
  subtitle:
    'Tres bloques mensuales + identidad de arranque: todo lo que Harrison necesita para sostener su espacio en TNO Network.',
  items: [
    {
      title: 'Programa en estudio (Bloque 1)',
      subtitle:
        '$100 USD/mes — preproducción, grabación y post en TNO Media Lab; episodio listo en tu espacio TNO Network.',
      colorKey: 'blue',
    },
    {
      title: 'Clips para redes (Bloque 2)',
      subtitle:
        '12 clips por episodio — incluidos en el paquete adicional de $50 USD/mes (Instagram, TikTok, LinkedIn, X).',
      colorKey: 'amber',
    },
    {
      title: 'YouTube promocional (Bloque 3)',
      subtitle:
        '4 clips promocionales por episodio que empujan tráfico a tu espacio en TNO — mismo paquete de $50 USD/mes.',
      colorKey: 'pink',
    },
    {
      title: 'Bonificación TNO Digest',
      subtitle:
        '4 artículos mensuales en tnonetwork.com con SEO y enlaces a tu programa.',
      colorKey: 'teal',
    },
  ],
};

export const harrisonMozoMediaLabValues = {
  overline: 'Valores del Lab',
  title: 'ADN del espacio creador',
  hideAdnHeading: true,
  subtitle:
    'De audiencia viral a presencia broadcast: TNO Media Lab y TNO Network como casa del programa de @harriviral.',
  items: [
    {
      title: 'Espacio propio',
      subtitle: 'Programa alojado en la plataforma TNO Network — streaming, on-demand y tnonetwork.com.',
    },
    {
      title: 'Alcance + conversión',
      subtitle:
        'Clips sociales y piezas promocionales en YouTube que redirigen a tu grilla en TNO.',
    },
    {
      title: 'Comercialización',
      subtitle:
        'Opcional: patrocinador de Harrison → 30% TNO; patrocinador de la radio → 50% Harrison y 50% TNO.',
    },
    {
      title: 'Tarifas claras',
      subtitle:
        '$150 USD/mes: programa $100 + paquete clips $50 adicional. Arranque gráfico: $120 USD (única vez).',
    },
  ],
};

export const harrisonMozoMediaLabAreYouReady = {
  headline: 'Activemos el espacio de Harrison Mozo en TNO Network',
  subheadline: '¿Listos para el primer ciclo mensual?',
  body:
    'Coordinemos identidad de arranque, calendario de grabación y publicación del primer episodio de @harriviral en TNO Network.',
  ctaPrimary: 'Quiero activar mi espacio',
  ctaSecondary: 'TNO Media Lab',
  ctaSecondaryHref: '/medialab',
  whatsappNumber: '04123964576',
  footerText:
    '© TNO Network 2026 | Harrison Mozo (@harriviral) × TNO Media Lab | The Content Evolution.',
};
